import { render, staticRenderFns } from "./AppBarraSuperior.vue?vue&type=template&id=0fa4bd41&"
import script from "./AppBarraSuperior.vue?vue&type=script&lang=js&"
export * from "./AppBarraSuperior.vue?vue&type=script&lang=js&"
import style0 from "./AppBarraSuperior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports